import { LollipopBuffer, LollipopSeries } from 'plugin-live-exploratory-viz/src/lollipop/types'

export function mergeEvents(series: LollipopSeries[], points: LollipopBuffer[]): LollipopSeries[] {
    const seriesFromEvent = points.reduce((series, currentPoint) => {
        const alreadyExistsSerieIndex = series.findIndex(serie => serie.name === currentPoint.name)

        if (alreadyExistsSerieIndex > -1) {
            const seriesCopy = [...series]
            const serie = seriesCopy[alreadyExistsSerieIndex]

            const { x, y, color, radius, symbol } = currentPoint
            const newSerie = {
                name: serie.name,
                color,
                marker: {
                    radius: radius || serie.marker.radius || null,
                    symbol: symbol || serie.marker.symbol || null
                },
                points: [...serie.points, { x, y }]
            }

            seriesCopy[alreadyExistsSerieIndex] = newSerie

            return seriesCopy
        }

        const { x, y, color, radius, symbol, name } = currentPoint
        const newSerie = {
            name,
            color,
            marker: {
                radius: radius || null,
                symbol: symbol || null
            },
            points: [{ x, y }]
        }

        return [...series, newSerie]
    }, series)

    return seriesFromEvent
}

export function getMetasValuesFromEvent<T = Record<string, unknown>>(
    events: T,
    supportedMetas: string[],
    removeUndescore?: boolean
): Record<string, unknown> {
    let metas = {}

    for (const key in events) {
        let founded = supportedMetas.find(meta => meta === key)
        if (founded) {
            if (removeUndescore) founded = founded.replace('__', '')
            metas = {
                ...metas,
                [founded]: events[key]
            }
        }
    }

    return metas
}
